(() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-mobile-header]').forEach(header => {
      if (header.dataset.navigationReady) return;
      const toggle = header.querySelector('[data-menu-toggle]');
      const panel = header.querySelector('[data-menu-panel]');
      if (!toggle || !panel) return;
      const label = toggle.querySelector('[data-menu-label]');
      const icon = toggle.querySelector('[data-menu-icon]');
      function setOpen(open, restoreFocus = false) {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        label.textContent = open ? '閉じる' : 'メニュー';
        icon.textContent = open ? '×' : '☰';
        if (restoreFocus) toggle.focus();
      }
      toggle.addEventListener('click', () => setOpen(panel.hidden));
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          setOpen(false, true);
        }
      });
      const desktop = window.matchMedia('(min-width: 801px)');
      desktop.addEventListener('change', event => {
        if (event.matches) {
          if (panel.contains(document.activeElement) || document.activeElement === toggle) {
            header.querySelector('.a-wordmark').focus();
          }
          setOpen(false);
        }
      });
      setOpen(false);
      toggle.hidden = false;
      header.dataset.navigationReady = 'true';
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
